import React from 'react';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const productLinks = [
    { name: 'Features', href: '#features' },
    { name: 'Academy', href: '#academy' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'Security', href: '#security' },
    { name: 'Download', href: '#download' },
  ];

  const companyLinks = [
    { name: 'About', href: '/about.html' },
    { name: 'Support', href: '/support.html' },
    { name: 'Careers', href: 'mailto:careers@findellapp.com', label: 'careers@findellapp.com' },
    { name: 'Press', href: 'mailto:press@findellapp.com', label: 'press@findellapp.com' },
    { name: 'Contact', href: 'mailto:support@findellapp.com', label: 'support@findellapp.com' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', href: 'https://findellapp.com/privacy.html' },
    { name: 'Terms of Service', href: 'https://findellapp.com/terms.html' },
    { name: 'EULA', href: 'https://findellapp.com/eula.html' },
    { name: 'Financial Disclaimer', href: 'https://findellapp.com/terms.html#disclaimer' },
  ];

  const socialLinks = [
    { name: 'Instagram', icon: Instagram, href: 'https://instagram.com/findellapp' },
  ];

  return (
    <footer
      data-testid="footer"
      className="bg-[#1B4332] pt-20 pb-8"
    >
      <div className="container-custom">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - Logo & Social */}
          <div>
            <a
              href="/"
              data-testid="footer-logo"
              className="inline-flex items-center gap-2 font-heading text-2xl font-bold text-[#FAFAF7] mb-4"
            >
              Findell <span className="text-xl">🌿</span>
            </a>
            <p className="font-body text-sm text-[#FAFAF7]/70 mb-6 leading-relaxed">
              Stop tracking your money.
              <br />
              Start transforming it.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  data-testid={`footer-social-${social.name.toLowerCase()}`}
                  className="w-10 h-10 bg-[#FAFAF7]/10 rounded-full flex items-center justify-center text-[#FAFAF7]/70 hover:bg-[#D4AF37] hover:text-[#1B4332] transition-all duration-300"
                  aria-label={social.name}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 - Product */}
          <div>
            <h4 className="font-body text-sm font-semibold text-[#FAFAF7] uppercase tracking-wider mb-4">
              Product
            </h4>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="font-body text-sm text-[#FAFAF7]/70 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Company */}
          <div>
            <h4 className="font-body text-sm font-semibold text-[#FAFAF7] uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="font-body text-sm text-[#FAFAF7]/70 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Legal */}
          <div>
            <h4 className="font-body text-sm font-semibold text-[#FAFAF7] uppercase tracking-wider mb-4">
              Legal
            </h4>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="font-body text-sm text-[#FAFAF7]/70 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#FAFAF7]/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-body text-xs text-[#FAFAF7]/50 text-center sm:text-left">
              © 2026 WayBetter Technologies LLC, doing business as Findell. All rights reserved.
            </p>
            <p className="font-body text-xs text-[#FAFAF7]/40 text-center sm:text-right max-w-md">
              Findell is not a licensed financial advisor. Vera provides educational guidance only.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
